import { RequestsService } from "../../../api";
export const updateFormData = async (
  requestId: string,
  key: string,
  value: any,
  setDetails?: React.Dispatch<any>
) => {
  // 1️⃣ Optimistic UI update (only if provided)
  if (setDetails) {
    setDetails((prev: any) => ({
      ...prev,
      form_data: {
        ...prev.form_data,
        [key]: {
          ...(prev.form_data?.[key] ?? {}),
          ...value,
        },
      },
    }));
  }

  // 2️⃣ Backend update (always)
  await RequestsService.patchFormBlockServiceRequestsRequestIdFormDataBlockPatch(
    Number(requestId),
    encodeURIComponent(key), 
    {
      data: value,
    }
  );
};